/**
 * Configuración de Novedades y Actualizaciones (What's New) de VitaliaCare.
 * Modificar NOVEDADES_VERSION para hacer que el modal vuelva a mostrarse automáticamente a todos los usuarios.
 */
export const NOVEDADES_VERSION = 'vitalia-novedades-2026-09-v1'

export const NOVEDADES_DATA = {
    version: NOVEDADES_VERSION,
    tag: 'Actualización Septiembre 2026',
    titulo: '¡Nuevas funciones disponibles en VitaliaCare!',
    subtitulo: 'Hemos incorporado potentes herramientas de Inteligencia Artificial y autogestión para transformar tu flujo de trabajo clínico.',
    items: [
        {
            id: 'agendamiento-publico',
            tipo: 'calendar',
            badge: 'Nuevo',
            badgeClass: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20',
            iconoBg: 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800/50',
            titulo: 'Agendamiento Público de Citas Online',
            descripcion: 'Comparte tu enlace personalizado o código QR. Tus pacientes podrán reservar citas online 24/7 en tus horarios disponibles con sincronización automática de citas y confirmación por correo.',
            ruta: '/citas',
            textoAccion: 'Ir a Citas',
        },
        {
            id: 'ocr-laboratorios-ia',
            tipo: 'document',
            badge: 'IA Médica',
            badgeClass: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border border-purple-500/20',
            iconoBg: 'bg-purple-50 dark:bg-purple-950/40 text-purple-600 dark:text-purple-400 border-purple-200 dark:border-purple-800/50',
            titulo: 'OCR Inteligente de Laboratorios con IA',
            descripcion: 'Sube estudios de laboratorio en PDF o imagen. El motor de IA extrae analíticas biomédicas, detecta rangos de referencia, genera semáforos de alerta y los adjunta al expediente en 1 clic.',
            ruta: '/pacientes',
            textoAccion: 'Ver en Pacientes',
        },
        {
            id: 'escriba-ambiental',
            tipo: 'microphone',
            badge: 'Copiloto IA',
            badgeClass: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20',
            iconoBg: 'bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 border-blue-200 dark:border-blue-800/50',
            titulo: 'Escriba Clínico & Dictado por Voz',
            descripcion: 'Dicta consultas o activa el asistente ambiental para transcribir y estructurar automáticamente el motivo de consulta, examen físico y plan de tratamiento ahorrando hasta 70% de tiempo.',
            ruta: '/historias',
            textoAccion: 'Explorar Historias',
        },
        {
            id: 'seguridad-alergias',
            tipo: 'shield',
            badge: 'Seguridad',
            badgeClass: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20',
            iconoBg: 'bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border-amber-200 dark:border-amber-800/50',
            titulo: 'Alertas de Alergias e Interacciones en Recetas',
            descripcion: 'Detección proactiva de contraindicaciones y alergias de pacientes al formular medicamentos, minimizando riesgos clínicos durante la prescripción.',
            ruta: '/pacientes',
            textoAccion: 'Revisar Fichas',
        },
    ],
}
